import bFormInput from './form-input.vue';

export default bFormInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/form-input/form-input.js
// module id = 336
// module chunks = 0